import { linearGradientDef } from '@nivo/core';
import { ResponsiveLine } from '@nivo/line';

export const ReportLineChart = ({ data = [], color, tooltipLabel }) => {
  const chartData = [
    {
      id: tooltipLabel,
      data: data.map(({ Key, Value }) => ({
        x: Key,
        y: Value,
      })),
    },
  ];

  return (
    <ResponsiveLine
      data={chartData}
      curve="monotoneX"
      margin={{ top: 5, left: 5, right: 5, bottom: 5 }}
      enableArea
      colors={[color]}
      axisLeft={null}
      axisBottom={null}
      enableSlices="x"
      pointBorderColor="white"
      pointSize={8}
      pointBorderWidth={2}
      defs={[
        linearGradientDef('gradientA', [
          { offset: 0, color: 'inherit' },
          { offset: 100, color: 'inherit', opacity: 0.4 },
        ]),
      ]}
      fill={[{ match: '*', id: 'gradientA' }]}
      theme={{
        grid: {
          line: {
            stroke: '#fafafa',
          },
        },
      }}
      sliceTooltip={({ slice }) => {
        const data = slice.points[0].data;
        return (
          <div className="flex flex-col p-2 rounded-md border-gray-500 bg-white shadow-sm">
            <span className="text-lg font-medium">
              {tooltipLabel}: {Math.round(data.y)}
            </span>
            <span>{data.x}</span>
          </div>
        );
      }}
    />
  );
};
